import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MoreProfileView from './more-profile.view';
import { EtcApi, GetProfileResponse } from '../../../../apis/v1/etc.api';
import useAuthentication from '../../../../store/useAuthentication';

const MoreProfile = () => {
  const { authentication } = useAuthentication();
  const etcApi = new EtcApi(process.env.REACT_APP_ENV !== 'dev', authentication.accessToken, authentication.deviceId);
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState<GetProfileResponse>();
  useEffect(() => {
    if (authentication.accessToken && authentication.deviceId) {
      const fetchData = async () => {
        try {
          const { data }: any = await etcApi.getProfileAsync();
          setProfileData(data);
        } catch (error) {
          // console.error(error);
          // await window.flutter_inappwebview.callHandler('goErrorPage', '');
        }
      };
      fetchData();
    }
  }, [authentication.accessToken, authentication.deviceId]);

  const handleGoBack = () => {
    navigate('/more');
  };



  const handleLogoutButton = async () => {
    if (process.env.REACT_APP_BUILD === 'flutter') {
      // @ts-ignore
      await window.flutter_inappwebview.callHandler('logout', 'string message');
    } else {
      alert('로그아웃');
    }
  };

  const props = {
    handleLogoutButton,
    handleGoBack,
    profileData,
  };

  return <MoreProfileView {...props} />;
};

export default MoreProfile;
